export const ACCELERATE_BASE_URL = '/accelerate';
export const ACCELERATE_BASE_URL_2021 = '/accelerate/2021';
export const ACCELERATE_BASE_URL_2022 = '/accelerate/2022';
